import gql from 'graphql-tag'

export default gql`
mutation(
  $appointmentId: ID!
) {
  createAppointmentStripePaymentIntent(
    appointmentId: $appointmentId
  )
}`
